import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']

    return {
        columns: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'flex-start',
            [theme.breakpoints.up(1024)]: {
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'start'
            },
            borderRadius: '20px',
            border: `1px solid ${colors.primary[400]}`,
            background: '#FFF',
            padding: '0 30px',
            gap: '30px'
        },
        leftColumn: {
            padding: '30px 0 20px 0',
            [theme.breakpoints.up(1024)]: {
                maxWidth: '500px'
            }
        },
        rightColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
            alignSelf: 'stretch',
            border: 0,
            padding: 0,
            [theme.breakpoints.up(1024)]: {
                maxWidth: '250px',
                padding: '30px 0 30px 30px',
                borderLeft: `1px solid ${colors.neutral[100]}`
            }
        }
    }
})

/**
 * Re-usable order 2 column layout used by multiple steps of the sign-up process.
 */
const OrderLayout = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const classes = useStyles()
    return (
        <div className={classes.columns}>
            {children}
        </div>
    )
}

/**
 * Larger, left column within the OrderLayout
 */
export const OrderLayoutLeftColumn = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const classes = useStyles()
    return (
        <div className={classes.leftColumn}>
            {children}
        </div>
    )
}

/**
 * Smaller, right column within the OrderLayout.
 * This collapses belows the left column on small screens.
 */
export const OrderLayoutRightColumn = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const classes = useStyles()
    return (
        <div className={classes.rightColumn}>
            {children}
        </div>
    )
}

export default OrderLayout
